import React, { Component } from 'react';
import RenderErrorText from '../../shared/components/RenderErrorText';


class ErrorSection extends React.Component {

  render() {
    let { text } = this.props;
    return(
      <div className="ie-fix mt2 p3 mb-shadow-box">
        <div className="cs-warning-message-wrapper error pt2 mt0">
          <RenderErrorText text={text} />
        </div>
      </div>
    );
  }
}

export default ErrorSection;
